import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { EmbeddedMapTileSwiperProvider } from 'components/map/map-controller/tiles/shared/simpleTile-click-context';
import { PageNavigationHook } from 'components/tracking/page-navigation-hook.js';
import 'core-js/proposals/array-flat-map'; // added to tsconfig li.js';
import 'core-js/proposals/string-replace-all'; // added to tsconfig li.js';
import { ErrorPage } from 'layout/error-page.js';
import { ColumnLayoutProvider } from 'page-context/column-layout/column-layout-context.js';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { store } from 'redux-state/configure-store.js';
import 'regenerator-runtime/runtime.js';
import { MainJsonV2 } from 'routing/main-2-json-v2.js';
import 'styles/app.scss';
import { AdUtilsInit } from 'utilities/adUtils/adUtils.js';
import { ddConfigInit } from 'utilities/helpers/config.dataDog.js';
import { nielsenInit } from 'utilities/helpers/config.nielsen';
import { phConfigInit } from 'utilities/helpers/config.postHog.js';
import { AppVersionProvider } from 'utilities/hooks/context-app-version.js';
import { FuseAdsProvider } from 'utilities/hooks/fuse-ads-context.js';
import { PageChangeProvider } from 'utilities/hooks/page-change-provider.js';
import { getWindow, setWindow } from 'utilities/window.js';

const lclWindow = getWindow();

if (lclWindow) {
  lclWindow.MetService = lclWindow?.MetService || {};
  lclWindow.AdUtils = lclWindow.AdUtils || AdUtilsInit;
}

/** Posthog */
phConfigInit();

/** DataDog */
ddConfigInit();

/** Nielson */
setWindow('nielsenQueue', nielsenInit());

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: '/*',
    element: (
      <EmbeddedMapTileSwiperProvider>
        <PageChangeProvider>
          <PageNavigationHook>
            <MainJsonV2 />
          </PageNavigationHook>
        </PageChangeProvider>
      </EmbeddedMapTileSwiperProvider>
    ),
    errorElement: <ErrorPage />,
  },
]);

// from public/index.html

const el = lclWindow?.document?.getElementById?.('root');
if (el) {
  const root = createRoot(el);
  root.render(
    <AppVersionProvider>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ColumnLayoutProvider>
            <FuseAdsProvider>
              <RouterProvider router={router} />
            </FuseAdsProvider>
          </ColumnLayoutProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    </AppVersionProvider>,
  );
}
